import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CalendarService extends ApiService {

  constructor(http: HttpClient) {
    super(`${environment.apiUrl}`, http);
  }

  getCalendar(viewAll?: boolean, userID?: number | string, startDate?: string, endDate?: string) {
    const params: any = {};
    if (viewAll != null && viewAll !== undefined) {
      params.viewAll = viewAll;
    }
    if (userID != null && userID !== undefined) {
      params.userID = userID;
    }
    if (startDate != null && startDate !== undefined && startDate !== '') {
      params.startDate = startDate;
    }
    if (endDate != null && endDate !== undefined && endDate !== '') {
      params.endDate = endDate;
    }
    if (Object.keys(params).length === 0) {
      return this.getUrl('/calendar');
    }
    return this.getWithParams('/calendar', params);
  }

  postVisit(data) {
    return this.postUrl('/calendar/visit', data);
  }

  postVisitWithFile(formData: FormData) {
    return this.postFormData('/calendar/visit', formData);
  }

  putVisit(id, data) {
    return this.putUrl('/calendar/visit/' + id, data);
  }

  putVisitWithFile(id: number | string, formData: FormData) {
    return this.putFormData('/calendar/visit/' + id, formData);
  }

  /** Construye FormData para crear/actualizar visita con archivo PDF. */
  buildVisitFormData(data: any, file: File): FormData {
    const formData = new FormData();
    if (data.date != null) formData.append('date', data.date);
    if (data.contactIds != null) formData.append('contactIds', JSON.stringify(data.contactIds));
    formData.append('partner', data.partner != null ? String(data.partner) : '');
    if (data.time != null) formData.append('time', String(data.time));
    if (data.type != null) formData.append('type', String(data.type));
    if (data.summary != null) formData.append('summary', data.summary);
    if (data.typeClient != null) formData.append('typeClient', data.typeClient);
    formData.append('visitPdf', file);
    return formData;
  }

  postActivity(data) {
    return this.postUrl('/calendar/activity', data);
  }

  putActivity(id, data) {
    return this.putUrl('/calendar/activity/' + id, data);
  }

  deleteActivity(id) {
    return this.deleteUrl('/calendar/activity/' + id);
  }
}
